import { render } from "./KontakKami.vue?vue&type=template&id=a87cd92c"
import script from "./KontakKami.vue?vue&type=script&lang=js"
export * from "./KontakKami.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__